import { Card, CardContent, CardHeader, Typography } from "@mui/material";
import { useMetricsCaroline } from "../../app/hooks";

export default function Metrics() {
  const { metrics } = useMetricsCaroline();

  const count = metrics?.conv_count;
  const medInput = metrics?.med_input;
  const avgInput = metrics?.avg_input;
  const maxInput = metrics?.max_input;
  const minInput = metrics?.min_input;
  const medOutput = metrics?.med_output;
  const avgOutput = metrics?.avg_output;
  const maxOutput = metrics?.max_output;
  const minOutput = metrics?.min_output;
  const positiveFeedback = metrics?.positive_feedback;
  const negativeFeedback = metrics?.negative_feedback;

  return (
    <>
      <Card sx={{ width: "100%", maxWidth: "sm" }}>
        <CardHeader
          title="Caroline"
          titleTypographyProps={{ color: "primary" }}
          subheader="Metrics for Caroline"
        />
        <CardContent>
          <Typography>
            <Typography component="span" color="text.secondary">
              Total converations:{" "}
            </Typography>
            {count}
          </Typography>

          <br />

          <Typography>
            <Typography component="span" color="text.secondary">
              Median input tokens:{" "}
            </Typography>
            {medInput}
          </Typography>

          <Typography>
            <Typography component="span" color="text.secondary">
              Average input tokens:{" "}
            </Typography>
            {avgInput}
          </Typography>

          <Typography>
            <Typography component="span" color="text.secondary">
              Maximum input tokens:{" "}
            </Typography>
            {maxInput}
          </Typography>

          <Typography>
            <Typography component="span" color="text.secondary">
              Minimum input tokens:{" "}
            </Typography>
            {minInput}
          </Typography>

          <br />

          <Typography>
            <Typography component="span" color="text.secondary">
              Median output tokens:{" "}
            </Typography>
            {medOutput}
          </Typography>

          <Typography>
            <Typography component="span" color="text.secondary">
              Average output tokens:{" "}
            </Typography>
            {avgOutput}
          </Typography>

          <Typography>
            <Typography component="span" color="text.secondary">
              Maximum output tokens:{" "}
            </Typography>
            {maxOutput}
          </Typography>

          <Typography>
            <Typography component="span" color="text.secondary">
              Minimum output tokens:{" "}
            </Typography>
            {minOutput}
          </Typography>

          <br />

          <Typography>
            <Typography component="span" color="text.secondary">
              Positive feedback:{" "}
            </Typography>
            {positiveFeedback}
          </Typography>

          <Typography>
            <Typography component="span" color="text.secondary">
              Negative feedback:{" "}
            </Typography>
            {negativeFeedback}
          </Typography>
        </CardContent>
      </Card>
    </>
  );
}
